var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `BeoScrollPanel` is a typed wrapper around PrimeReact's `ScrollPanel`,
 * allowing for custom props through the `BeoScrollPanelProps` interface.
 *
 * It forwards the `ref` and all other props directly to the underlying `ScrollPanel`
 * and renders its children inside.
 *
 * @component
 *
 * @param {BeoScrollPanelProps} props - Props passed to the ScrollPanel component.
 * @param {React.Ref<any>} props.ref - Ref forwarded to the ScrollPanel.
 * @param {React.ReactNode} props.children - Elements to render inside the scroll panel.
 *
 * @returns {JSX.Element} A styled scrollable container using PrimeReact's ScrollPanel.
 * @author rajeev.k
 * @example
 * <BeoScrollPanel style={{ width: '100%', height: '300px' }}>
 *   <p>Scrollable content here</p>
 * </BeoScrollPanel>
 */
import { ScrollPanel } from "primereact/scrollpanel";
var BeoScrollPanel = function (_a) {
    var ref = _a.ref, props = __rest(_a, ["ref"]);
    return (_jsx(ScrollPanel, __assign({ ref: ref }, props, { children: props.children })));
};
export default BeoScrollPanel;
